var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "multi-biologicals-listing"
    }
  }, [_c('div', {
    staticClass: "projects-links"
  }, [_vm.displayBanner ? _c('v-banner', {
    staticClass: "reminder-banner",
    attrs: {
      "color": "info"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bannerText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.displayLinks ? _c('BioProjectMaterialsModal', {
    attrs: {
      "group-nid": _vm.groupNid,
      "is-in-bio-materials": true,
      "data-test": "project-link-0"
    }
  }) : _vm._e(), _vm._v(" "), _vm.specifyLink ? _c('a', {
    attrs: {
      "href": _vm.specifyLink,
      "data-test": "project-link-1"
    }
  }, [_vm._v("Specify Usage for Projects")]) : _vm._e()], 1), _vm._v(" "), _vm._l(_vm.bioMaterialTypes, function (material) {
    return _c('div', {
      key: material
    }, [!_vm.groupNid ? _c('InstitutionalBiologicalsListing', {
      attrs: {
        "material-type": material
      }
    }) : _vm._e(), _vm._v(" "), _vm.groupNid ? _c('GroupContextBiologicalsListing', {
      attrs: {
        "material-type": material,
        "group-nid": _vm.groupNid,
        "display-id": _vm.displayId
      }
    }) : _vm._e()], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }